import { AddContractorBody } from "@/models/api/administration/contractors/AddContractorBody";
import { BIRResponse } from "@/models/api/administration/contractors/BIRResponse";
import {
  ContractorBasicInfoResponse,
  ContractorSetting,
} from "@/models/api/administration/contractors/ContractorBasicInfoResponse";
import { EditContractor } from "@/models/api/administration/contractors/EditContractor";
import SelectItem from "@/models/components/inputs/selectItem";
import CancellableHelper from "@/requests/CancellableHelper";

//#region routes
export const URL_GET_CONTRACTORS_BASIC_INFO = "/ContractorAdministration/${ContractorId}";
export const URL_GET_VALIDATE_TIN_IN_VIES = "/ContractorAdministration/ValidateTinInVies";
export const URL_GET_CALCULATE_CURRENT_DEBT =
  "/ContractorAdministration/${ContractorId}/CalculateCurrentDebt/${CurrentDebt}";
export const URL_POST_EDIT_CONTRACTOR_SETTING = "/ContractorAdministration/${ContractorId}/Setting/Edit";
export const URL_POST_EDIT_CONTRACTOR = "/ContractorAdministration/${ContractorId}/Edit";
export const ULR_GET_SEARCH_CONTRACTOR_IN_BIR = "/ContractorAdministration/SearchInBIR";
export const ULR_POST_ADD_CONTRACTOR = "/ContractorAdministration/Add";
export const URL_GET_CONTRACTOR_CATEGORIES = "/ContractorAdministration/Categories";
//#endregion

const _getContractorBasicInfo = new CancellableHelper<ContractorBasicInfoResponse>(
  URL_GET_CONTRACTORS_BASIC_INFO,
  ContractorBasicInfoResponse
);
export const getContractorBasicInfo = async (contractorId: string): Promise<ContractorBasicInfoResponse> => {
  return await _getContractorBasicInfo.get({ ContractorId: contractorId });
};

const _getContractorBasicInfoToEdit = new CancellableHelper<ContractorBasicInfoResponse>(
  URL_GET_CONTRACTORS_BASIC_INFO,
  ContractorBasicInfoResponse
);
export const getContractorBasicInfoToEdit = async (contractorId: string): Promise<ContractorBasicInfoResponse> => {
  return await _getContractorBasicInfoToEdit.get({
    ContractorId: contractorId,
  });
};

const _calculateCurrentDebt = new CancellableHelper<number>(URL_GET_CALCULATE_CURRENT_DEBT, "number");
export const calculateCurrentDebt = async (contractorId: string, currentDebt: number): Promise<number> => {
  return await _calculateCurrentDebt.get({
    ContractorId: contractorId,
    CurrentDebt: currentDebt,
  });
};

const _editContractorSetting = new CancellableHelper<null>(URL_POST_EDIT_CONTRACTOR_SETTING, null, true);
export const editContractorSetting = async (
  contractorId: string,
  contractorSetting: ContractorSetting
): Promise<null> => {
  return await _editContractorSetting.post({ ContractorId: contractorId }, contractorSetting);
};

const _editContractor = new CancellableHelper<null>(URL_POST_EDIT_CONTRACTOR, null, true);
export const editContractor = async (contractorId: string, contractor: EditContractor): Promise<null> => {
  return await _editContractor.post({ ContractorId: contractorId }, contractor);
};

const _searchContractorInBIR = new CancellableHelper<BIRResponse>(ULR_GET_SEARCH_CONTRACTOR_IN_BIR, null, true);
export const searchContractorInBIR = async (tin: string): Promise<BIRResponse> => {
  return _searchContractorInBIR.get({ tin: tin });
};

const _addContractor = new CancellableHelper<string>(ULR_POST_ADD_CONTRACTOR);
export const addContractor = async (newContractor: AddContractorBody): Promise<string> => {
  return _addContractor.post({}, newContractor);
};

const _getContractorCategories = new CancellableHelper<Array<SelectItem>>(URL_GET_CONTRACTOR_CATEGORIES);
export const getContractorCategories = async (): Promise<Array<SelectItem>> => {
  return _getContractorCategories.get();
};

const _getValidateTinInVies = new CancellableHelper<boolean>(URL_GET_VALIDATE_TIN_IN_VIES, "boolean");
export const getValidateTinInVies = async (tin: string, countryCode: string): Promise<boolean> => {
  return _getValidateTinInVies.get({
    tin: tin,
    countryCode: countryCode,
  });
};
